function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.722 17.333a.166.166 0 01.164.194C19.64 19.06 18.312 20 16.278 20H7.61c-2.035 0-3.361-.938-3.609-2.473a.166.166 0 01.165-.194zM16.944 18a.5.5 0 100 1 .5.5 0 000-1zm-2 0a.5.5 0 100 1 .5.5 0 000-1zm2.313-7.5c.068 0 .13.041.155.105l2.333 5.833a.167.167 0 01-.155.229H4.298a.167.167 0 01-.154-.228l2.333-5.834a.167.167 0 01.155-.104zm-1.646 1.167H8.278a.333.333 0 00-.31.21L6.635 15.21a.333.333 0 00.31.457h10a.333.333 0 00.309-.458l-1.334-3.333a.333.333 0 00-.31-.21zM18.278 4a.333.333 0 01.325.406L17.5 9.367a.167.167 0 01-.162.134L6.55 9.503a.167.167 0 01-.163-.133L5.286 4.405A.333.333 0 015.61 4z"
});

function SvgPhotocopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgPhotocopy;